module.exports = __webpack_public_path__ + "img/t4-blue.c2e01183.png";